import { render, staticRenderFns } from "./OnlineModeratorsInformationTable.vue?vue&type=template&id=601dd966&"
import script from "./OnlineModeratorsInformationTable.vue?vue&type=script&lang=babel&"
export * from "./OnlineModeratorsInformationTable.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports